/* eslint-disable import/no-extraneous-dependencies */
// counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: null,
    token: null,
    chatData: [],
    chatListData: [],
    discoverData: [],
    fcmToken: null,
    notificationsCount: 0,
    notifications: [],
    enableRequest: false,
  },

  reducers: {
    addToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('mchathive-auth-token', action.payload);
    },
    setEnableRequest: (state, action) => {
      state.enableRequest = action.payload;
    },
    setNotificationsData: (state, action) => {
      state.notificationsCount = action.payload.notificationsCount;
      state.notifications = action.payload.notifications;
    },
    updateUser: (state, action) => {
      state.userInfo = action.payload;
    },
    setMostActiveChatData: (state, action) => {
      state.chatData = state.chatData
        ? {
            ...state.chatData,
            [action.payload.chatFrom]: action.payload.chatData,
          }
        : { [action.payload.chatFrom]: action.payload.chatData };
    },
    setChatDataList: (state, action) => {
      return {
        ...state,
        chatListData: action.payload,
      };
    },
    setDiscoverData: (state, action) => {
      return {
        ...state,
        discoverData: action.payload,
      };
    },

    logOut: (state) => {
      localStorage.removeItem('mchathive-auth-token');
      localStorage.removeItem('mchathive-auth-token-v2');
      state.userInfo = null;
    },
  },
});

export const {
  addToken,
  logOut,
  updateUser,
  setChatData,
  setChatDataList,
  setDiscoverData,
  setNotificationsData,
  setEnableRequest,
} = userSlice.actions;
export default userSlice.reducer;
